import { Form, ColorPicker } from 'antd';
import React from 'react';
import './style.css';

/**
 * Type definition for the color value in the ColorPicker component.
 */
type ColorType = Parameters<NonNullable<React.ComponentProps<typeof ColorPicker>['onChange']>>[0];

/**
 * Props for the ColorPickerWithLabel component.
 */
interface ColorPickerWithLabelProps {
  /** Callback function triggered when the color value changes. */
  onChange?: (value: ColorType) => void;
  /** Label text displayed above the color picker. */
  label?: string | React.ReactNode;
  /** Name for form integration (can be a string or an array of strings). */
  name?: string | string[];
  /** Controlled value for the color picker. */
  value?: string;
}

/**
 * A color picker component with an optional label, designed to integrate with Ant Design Form.
 *
 * @param {ColorPickerWithLabelProps} props - The component props.
 * @returns {JSX.Element} The rendered ColorPickerWithLabel component.
 */
const ColorPickerWithLabel: React.FC<ColorPickerWithLabelProps> = ({
  onChange,
  label = 'Select Color',
  name,
  value,
}) => {
  return (
    <div id="colorPickerWrapper" className="colorPickerWrapper">
      <div className="colorPickerLabel">{label}</div>
      <div className="coloPickerElement">
        <Form.Item style={{ width: '100%', marginBottom: '0px' }} name={name}>
          <ColorPicker
            defaultFormat="hex"
            showText={() => value}
            allowClear
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-start',
              background: '#F5F5F5',
              border: 'none',
            }}
            onChange={onChange}
            value={value}
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default ColorPickerWithLabel;
